import { Avatar, Flex, Text, Tooltip } from '@chakra-ui/react'
import { useSelector } from 'react-redux'
const EditingUsersDisplay = () => {
  const { workingOfferViewingUsers } = useSelector((state) => state.offers)

  /**
   * workingOfferEditingUser {
   *  userName: string;
   *  userId: string
   * }
   */
  const getNameInitial = (fullName) => {
    if (!fullName || fullName.length === 0) return ''
    return fullName[0]
  }

  return (
    <Flex gap="1" alignItems="center" bg="white">
      <Text as="b"> Editing User:</Text>

      {workingOfferViewingUsers.map((userDetail, index) => (
        <Tooltip key={userDetail.userId} label={userDetail.userName || ''}>
          <Avatar name={getNameInitial(userDetail.userName)} size="sm" border={index === 0 ? '3px solid green' : ''} />
        </Tooltip>
      ))}
    </Flex>
  )
}

export default EditingUsersDisplay
